import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useGame } from '@/context/GameContext';

const QUICK_LINKS = [
    { icon: '⚔️', label: 'The Grind', sub: 'Continue your quests', to: '/grind' },
    { icon: '🗡️', label: 'Armory', sub: 'Browse your knowledge', to: '/armory' },
    { icon: '🏆', label: 'Hall of Fame', sub: 'See who\'s leading', to: '/hall-of-fame' },
];

export default function DashboardPage() {
    const { stats } = useGame();

    return (
        <div className="min-h-screen p-6 md:p-10">
            <div className="max-w-4xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="mb-10"
                >
                    <h1 className="text-3xl md:text-4xl font-heading font-black uppercase tracking-widest text-game-text">
                        {stats?.handle ? `Welcome back, ${stats.handle}` : 'Base Camp'}
                    </h1>
                    <p className="text-game-muted mt-1 font-mono text-sm">Your base of operations.</p>
                </motion.div>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    {QUICK_LINKS.map((item, i) => (
                        <motion.div
                            key={item.to}
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3, delay: i * 0.07 }}
                        >
                            <Link
                                to={item.to}
                                className="group flex flex-col p-6 rounded-2xl bg-game-surface border border-white/5 hover:border-game-primary/30 transition-all hover:shadow-glow-primary hover:bg-game-surface-2"
                            >
                                <span className="text-4xl mb-4 leading-none">{item.icon}</span>
                                <span className="font-heading font-black text-sm uppercase tracking-widest text-game-text group-hover:text-game-primary-l transition-colors">
                                    {item.label}
                                </span>
                                <span className="text-game-muted text-xs mt-1 font-mono">{item.sub}</span>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
}
